import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  serviceCardChanged: ['service'],
  locationSelectedChanged: ['name'],
  reset: []
})

export const ServiceCardTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  locationSelected: '',
})

// Redux reducers
export const serviceCardChanged = (state, { service }) => {
  return state.replace({ ...service })
}

export const locationSelectedChanged = (state, { name }) => {
  return state.merge({ locationSelected: name })
}

export const serviceCardReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SERVICE_CARD_CHANGED]: serviceCardChanged,
  [Types.LOCATION_SELECTED_CHANGED]: locationSelectedChanged,
  [Types.RESET]: serviceCardReset
})



// WEBPACK FOOTER //
// ./src/redux/serviceCardRedux.js